import { useEffect, useState } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";

import { api } from "../../../../services/api";
import { requestDateFormat } from "../../../../services/utils";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { NoDataCard } from "../../../../components/parts";
import { Rank } from "./Rank";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  grid: {
    marginBottom: `${theme.spacing(5.75)}px`,
  },
  selectRoot: {
    fontSize: 12,
  },
  selectIcon: {
    right: -2,
  },
  span: {
    color: "#9FA2B4",
    fontSize: 14,
  },
}));

const options = [
  {
    id: 0,
    label: "Top Players",
  },
  {
    id: 1,
    label: "Similar Industry",
  },
  {
    id: 2,
    label: "Similar Region",
  },
];

const filtersBy = ["players", "industry", "region"];

export const PortfolioBenchmark = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [filterBy, setFilterBy] = useState(0);

  useEffect(() => {
    const getCarbonReductionRank = (url) => {
      api.get(url).then((resp) => setUsers(resp.data));
    };

    const getUrl = (period) => {
      let url = `/praas/v1/emission-impact/save-the-planet/carbon-reduction-rank/?filter_by=${filtersBy[filterBy]}`;
      if (period.name === "RANGE" && endDate) {
        url += `&from_date=${requestDateFormat(
          startDate
        )}&to_date=${requestDateFormat(endDate)}`;
        getCarbonReductionRank(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `&date_filter=${period.filter}`;
        getCarbonReductionRank(url);
      }
    };

    getUrl(period);
  }, [filterBy, period, startDate, endDate]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {users.length ? (
        <div className={classes.box} id="portfolio-benchmark">
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.grid}
          >
            <Grid item xs={8}>
              <Typography variant="h4">
                Portfolio Benchmark
                <span className={classes.span}>
                  {" "}
                  (tCO<sub>2</sub>)
                </span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                alignItems="baseline"
                justifyContent="flex-end"
                wrap="nowrap"
              >
                <Typography variant="subtitle2" style={{ marginRight: 10 }}>
                  by:
                </Typography>
                <Select
                  labelId="label"
                  id="select"
                  defaultValue={options[0].id}
                  autoWidth={true}
                  onChange={(e) => setFilterBy(e.target.value)}
                  disableUnderline
                  classes={{ root: classes.selectRoot, icon: classes.selectIcon }}
                >
                  {options.map((option, i) => (
                    <MenuItem key={i} value={option.id} style={{ fontSize: 12 }}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Grid>
          <Rank users={users} />
        </div>
      ) : <NoDataCard title="Portfolio Benchmark" />}
    </ShaDowBox>
  );
};
